import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { Role } from '../../models/auth.dto';
import { rolesInSameFamily } from '../../shared/role-families';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

export interface ChangeRoleDialogData {
  userId: string;
  userEmail: string;
  currentRole: Role;
}

@Component({
  selector: 'app-change-role-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './change-role-dialog.html',
  styleUrl: './change-role-dialog.scss',
})
export class ChangeRoleDialog {
  availableRoles: Role[];
  selectedRole: Role;

  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<ChangeRoleDialog>,
    private admin: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRoleDialogData
  ) {
    this.availableRoles = rolesInSameFamily(data.currentRole);
    this.selectedRole = data.currentRole;
  }

  get canSubmit(): boolean {
    return this.selectedRole !== this.data.currentRole;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.canSubmit) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin.changeRole(this.data.userId, { role: this.selectedRole }).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to change role.'));
      },
    });
  }
}
